import { codeToHtml } from 'shiki';
import { dsCodeTheme } from './theme';
import styles from './CodeBlock.module.css';

export interface CodeBlockProps {
  code: string;
  lang?: string;
  filename?: string;
}

export const CodeBlock = async ({
  code,
  lang = 'tsx',
  filename,
}: CodeBlockProps) => {
  const html = await codeToHtml(code.trimEnd(), {
    lang,
    theme: dsCodeTheme,
  });

  return (
    <figure className={styles.codeBlock}>
      {filename && (
        <figcaption className={styles.filename}>{filename}</figcaption>
      )}
      <div
        className={styles.code}
        // eslint-disable-next-line react/no-danger -- shiki output, built server-side
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </figure>
  );
};
